import moment from 'moment'

// Shared helpers for client-side .xlsx exports (exceljs is loaded lazily, only on export)

export const MONEY_FORMAT = '#,##0'
export const USD_FORMAT = '#,##0.00'
export const AMOUNT_FORMAT = '#,##0.###'
export const DATE_FORMAT = 'dd.mm.yyyy'
export const COLORS = {red: 'FFD32F2F', green: 'FF388E3C', headerFill: 'FFE8EAF6'}

const thinBorder = {style: 'thin', color: {argb: 'FFBDBDBD'}}
export const CELL_BORDER = {top: thinBorder, left: thinBorder, bottom: thinBorder, right: thinBorder}

export async function createWorkbook() {
  const {default: ExcelJS} = await import(/* webpackChunkName: "exceljs" */ 'exceljs')
  return new ExcelJS.Workbook()
}

// Excel stores dates without a timezone, so build them in UTC to keep the calendar day
export function toExcelDate(date) {
  const m = moment(date)
  return new Date(Date.UTC(m.year(), m.month(), m.date()))
}

// Integers without decimals, fractional quantities (kg, m) with up to 3 digits
export function amountFormat(value) {
  return Number.isInteger(Number(value)) ? MONEY_FORMAT : AMOUNT_FORMAT
}

export function styleHeaderRow(row) {
  row.eachCell(cell => {
    cell.font = {bold: true}
    cell.alignment = {horizontal: 'center', vertical: 'middle', wrapText: true}
    cell.fill = {type: 'pattern', pattern: 'solid', fgColor: {argb: COLORS.headerFill}}
    cell.border = CELL_BORDER
  })
}

export function safeFileName(name) {
  return name.replace(/[\\/:*?"<>|]/g, '').replace(/\s+/g, '_')
}

export async function downloadWorkbook(workbook, fileName) {
  const buffer = await workbook.xlsx.writeBuffer()
  const blob = new Blob([buffer], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'})
  const link = document.createElement('a')
  link.href = URL.createObjectURL(blob)
  link.download = safeFileName(fileName)
  document.body.appendChild(link)
  link.click()
  link.remove()
  setTimeout(() => URL.revokeObjectURL(link.href), 1000)
}
